// src/components/Timeline.js
import React from 'react';

const Timeline = () => {
  const events = [
    {
      date: '25th July 2025',
      icon: 'fas fa-paper-plane',
      title: 'Abstract Submission Deadline',
      description: 'Deadline for submitting your research abstracts'
    },
    {
      date: '5th August 2025',
      icon: 'fas fa-check-circle',
      title: 'Abstract Approval',
      description: 'Notification of accepted papers and presentations'
    },
    {
      date: '25th August 2025',
      icon: 'fas fa-file-upload',
      title: 'Full Paper Submission Deadline',
      description: 'Final submission of complete research papers'
    },
    {
      date: '30th August 2025',
      icon: 'fas fa-check-circle',
      title: 'Full Paper Approval',
      description: 'Final submission of complete research papers'
    },
    {
      date: '20th September 2025',
      icon: 'fas fa-id-card',
      title: 'Registration Deadline',
      description: 'Last date for conference registration'
    },
    {
      date: '8th-9th October 2025',
      icon: 'fas fa-brain',
      title: 'National Symposium on AI',
      description: 'Conference days'
    }
  ];

  return (
    <section id="timeline" className="timeline-section">
      <div className="container">
        <div className="section-header fade-in">
          <h2><i className="fas fa-clock me-2"></i>Important Dates</h2>
        </div>
        <div className="timeline">
          {events.map((event, index) => (
            <div className="timeline-item fade-in" key={index}>
              <div className="timeline-content">
                <div className="timeline-date">{event.date}</div>
                <h3><i className={`${event.icon} me-2`}></i>{event.title}</h3>
                {/* <p>{event.description}</p> */}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Timeline;